import {
  SET_BREADCRUMB,
  SET_CHANGED,
  SET_EXPAND_CHART,
  SET_GLOBAL_SETTING,
  SHOW_WARRING_CHANGE_MESSAGE
} from "./types"

export const setChanged = (changed, callback) => ({
  type: SET_CHANGED,
  changed,
  callback
})

export const setShowWarningMessage = (showWarringChangeMessage) => ({
  type: SHOW_WARRING_CHANGE_MESSAGE,
  showWarringChangeMessage,
})


export const setBreadcrumb = breadcrumb => ({
  type: SET_BREADCRUMB,
  breadcrumb
})

export const setExpandChart = expandChart => ({
  type: SET_EXPAND_CHART,
  expandChart
})


export const setGlobalSetting = globalSetting => ({
  type: SET_GLOBAL_SETTING,
  globalSetting
})
